export const SET_TESTIMONIAL = "SET_TESTIMONIAL";

export const setTestimonial = (testimonial) => {
  return {
    type: SET_TESTIMONIAL,
    payload: testimonial,
  };
};
